export default {"src":"/_next/static/media/0x4b0f1812e5df2a09796481ff14017e6005508003.3613fe0a.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};